
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface UploadResult {
  url: string;
  path: string;
}

/**
 * Uploads a file to the Supabase storage and returns the public URL
 */
export const uploadFile = async (file: File): Promise<UploadResult> => {
  // Generate a unique filename
  const fileExt = file.name.split('.').pop();
  const fileName = `${Date.now()}.${fileExt}`;
  const filePath = fileName;
  const bucketName = 'peo-quotes';
  
  try {
    // Upload the file directly without checking or creating the bucket
    const { error: uploadError, data } = await supabase.storage
      .from(bucketName)
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (uploadError) {
      console.error('Error uploading file:', uploadError);
      
      // Provide more helpful error messages
      if (uploadError.message.includes('bucket') || uploadError.message.includes('permission')) {
        toast.error('File upload failed: Storage bucket not available or insufficient permissions');
      } else {
        toast.error('File upload failed: ' + uploadError.message);
      }
      
      throw uploadError;
    }

    // Get the public URL
    const { data: { publicUrl } } = supabase.storage
      .from(bucketName)
      .getPublicUrl(filePath);

    return {
      url: publicUrl,
      path: filePath
    };
  } catch (error) {
    console.error('File upload failed:', error);
    throw error;
  }
}
